var _style, _path, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDirectProcessEmission(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 682.7 682.7",
    style: {
      enableBackground: "new 0 0 682.7 682.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{clip-path:url(#SVGID_2_);}\r\n\t.st2{fill:none;stroke:#000000;stroke-width:26.6666;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:13.3333;}\r\n\t.st3{fill:#E2E7EF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M202.7,669.3H25.5v-68.7h177.2V669.3z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 682.7,
    height: 682.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)",
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152.1,10H19.1v51.5h132.9V10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.1,61.5H19.1l27.3,167.7c9.8-8.2,22.3-13.1,36.1-13.1c14.3,0,27.4,5.4,37.3,14.2L152.1,61.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.6,272.3c0-31-25.1-56.2-56.2-56.2c-31,0-56.2,25.1-56.2,56.2s25.1,56.2,56.2,56.2 C113.5,328.4,138.6,303.3,138.6,272.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M138.6,272.3c0-31-25.1-56.2-56.2-56.2c-31,0-56.2,25.1-56.2,56.2s25.1,56.2,56.2,56.2 C113.5,328.4,138.6,303.3,138.6,272.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M273.2,435.7L138.4,277.1c-2.5,28.8-26.6,51.3-55.9,51.3c-0.3,0-0.6,0-0.8,0l147.8,146.7 c-0.5-2.3-0.7-4.7-0.7-7c0-18.8,15.2-34,34-34C266.3,434.1,269.9,434.6,273.2,435.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152.1,61.5H19.1l27.3,167.7c9.8-8.2,22.3-13.1,36.1-13.1c14.3,0,27.4,5.4,37.3,14.2L152.1,61.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M273.2,435.7L138.4,277.1c-2.5,28.8-26.6,51.3-55.9,51.3c-0.3,0-0.6,0-0.8,0l147.8,146.7 c-0.5-2.3-0.7-4.7-0.7-7c0-18.8,15.2-34,34-34C266.3,434.1,269.9,434.6,273.2,435.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M439.9,492.9v-42.5H291.7c3.3,5.3,5,11.4,5,17.7c0,9.8-4.2,18.7-10.8,24.9H439.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M439.9,492.9v-42.5H291.7c3.3,5.3,5,11.4,5,17.7c0,9.8-4.2,18.7-10.8,24.9H439.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M470.5,10H307.9l20.1,175h122.3L470.5,10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M470.5,10H307.9l20.1,175h122.3L470.5,10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M285.6,185h207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M422.3,185h-66.1v65.7h66.1V185z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M367.4,450.3v-69.5l20.8-44.1l19.8,44.1v69.5H367.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M367.4,450.3v-69.5l20.8-44.1l19.8,44.1v69.5H367.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M388.2,336.6V302"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.6,468c0-18.8-15.2-34-34-34s-34,15.2-34,34s15.2,34,34,34S296.6,486.8,296.6,468"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M296.6,468c0-18.8-15.2-34-34-34s-34,15.2-34,34s15.2,34,34,34S296.6,486.8,296.6,468z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.3,272.3c0-11.5-9.3-20.8-20.8-20.8c-11.5,0-20.8,9.3-20.8,20.8c0,11.5,9.3,20.8,20.8,20.8 C94,293.1,103.3,283.8,103.3,272.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.3,272.3c0-11.5-9.3-20.8-20.8-20.8c-11.5,0-20.8,9.3-20.8,20.8c0,11.5,9.3,20.8,20.8,20.8 C94,293.1,103.3,283.8,103.3,272.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.1,216.1V158"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.1,113L83.1,113"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectProcessEmission);
export default __webpack_public_path__ + "static/media/DirectProcessEmission.0eae7cec424b2bf910b1b2825bdd64cf.svg";
export { ForwardRef as ReactComponent };